import { appConfig, type AppLocale } from '@/shared/configs/app.config';

const localeMap: Record<AppLocale, string> = {
  sl: 'sl-SI',
  en: 'sl-SI',
  de: 'sl-SI',
  hr: 'sl-SI',
  it: 'sl-SI',
  fr: 'sl-SI',
  pl: 'sl-SI',
  et: 'sl-SI',
  es: 'sl-SI',
  cs: 'sl-SI',
  fi: 'sl-SI',
  hu: 'sl-SI',
  da: 'sl-SI',
};

const formatterCache = new Map<AppLocale, Intl.NumberFormat>();

const createFormatter = (locale: AppLocale): Intl.NumberFormat => {
  return new Intl.NumberFormat(localeMap[locale], {
    style: 'currency',
    currency: 'EUR',
    useGrouping: true,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const getFormatter = (locale: AppLocale): Intl.NumberFormat => {
  let formatter = formatterCache.get(locale);
  if (!formatter) {
    formatter = createFormatter(locale);
    formatterCache.set(locale, formatter);
  }
  return formatter;
};

// Client requirement: a price of 0 renders '/' just like a withheld (null)
// price — e.g. a 100% discount shows '/' for the total, matching production.
export const formatPrice = (price: number | null | undefined, locale?: AppLocale) => {
  if (price === null || price === undefined || price === 0) {
    return '/';
  }
  const formatter = getFormatter(locale ?? appConfig.fallbackLanguage);
  return formatter.format((price * 100) / 100);
};

export const isPrice = (price?: number | null) => price !== null && price !== undefined;

export const round = (value: number) => Math.round(value * 100) / 100;

export const parseDiscountValue = (value: FormDataEntryValue | null): number | null => {
  if (typeof value !== 'string') return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};
